import React from 'react';
import { Tag } from '@b-design/fusion';

import './index.less';

interface IProps {
  tagTheme: 'green' | 'blue' | 'orange' | 'purple' | 'grey' | 'red' | undefined;
  name: string | undefined;
  width?: string;
}

const ColorTags: React.FC<IProps> = ({ tagTheme, name, width }) => {
  const color = {
    green: {
      backgroundColor: '#EBFFF6',
      color: '#00C76D',
    },
    blue: {
      backgroundColor: '#F0FEFF',
      color: '#2DC7CD',
    },
    orange: {
      backgroundColor: '#FFF4ED',
      color: '#FF7E33',
    },
    purple: {
      backgroundColor: '#EDEAFF',
      color: '#6A4DFF',
    },
    grey: {
      backgroundColor: '#F0F0F0',
      color: '#646464',
    },
    red: {
      backgroundColor: '#FFF2F2',
      color: '#FD4340',
    },
  };

  const renderTag = (tagTheme, name) => {
    return (
      <Tag
        style={{
          ...color[tagTheme],
          textAlign: 'center',
          paddingLeft: 10,
          width,
        }}
      >
        <div className={`circle-status ${tagTheme}`} />
        <span className="list-status">{name}</span>
      </Tag>
    );
  };

  return <div className="status-tags-container">{renderTag(tagTheme, name)}</div>;
};

export default ColorTags;
